var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 304h112v32H256v-32zM256 496h400v32H256v-32zM256 688h240v32H256v-32zM704 432h-32v160h32v-80h64v-32h-64v-48zM544 624h-32v160h32v-80h224v-32H544v-48zM416 288v-48h-32v160h32v-80h352v-32H416z"
  })));
};
export default SvgFilter;